import { createSlice } from '@reduxjs/toolkit';

const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    activeMenuItem: '/',
  },
  reducers: {
    setActiveMenuItem(state, action) {
      state.activeMenuItem = action.payload;
    },
  },
});

export const { setActiveMenuItem } = menuSlice.actions;
export default menuSlice.reducer;
